<template>
  <b-card class="mb-2">
    <div slot="header">
      <h6>{{site.name}}</h6>
    </div>

    <b-row>
      <b-col md="1">
        <strong>{{site.city}}</strong>
      </b-col>
      <b-col md="10">
        <div v-html="getDecodedHtml(site.description)"></div>
      </b-col>
      <b-col md="1">
        <b-button variant="primary" :to="{ name: 'placementsSiteDetails', params: { siteId: site.siteId }}">View Details</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {};
  },

  props: {
    site: {
      type: Object,
      required: true
    }
  },

  methods: {
    getDecodedHtml(encodedString) {
      if (encodedString) {
        return htmlDecode(encodedString);
      }
      return "";
    }
  }
};
</script>

<style scoped>
</style>
